"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodizerClasses = exports.AccumulatorClasses = void 0;
var AccumulatorClasses;
(function (AccumulatorClasses) {
    AccumulatorClasses["HourlyYearBasedNormalAccumulator"] = "HourlyYearBasedNormalAccumulator";
})(AccumulatorClasses || (exports.AccumulatorClasses = AccumulatorClasses = {}));
var PeriodizerClasses;
(function (PeriodizerClasses) {
    PeriodizerClasses["DailyDecadePeriodizer"] = "DailyDecadePeriodizer";
    PeriodizerClasses["HourlyYearPeriodizer"] = "HourlyYearPeriodizer";
    PeriodizerClasses["QuarterHourPeriodizer"] = "QuarterHourPeriodizer";
})(PeriodizerClasses || (exports.PeriodizerClasses = PeriodizerClasses = {}));
